import React from 'react';
import PropTypes from 'prop-types';
import { EventTitle } from './EventTitle';
import { EventActions } from './EventActions';
import { EventDetailsSummary } from './event-details';
import { ModalDetailsEvent } from './modalSelectEvent/style';
import { FormWrapper } from '../../formWrapper/form-wrapper';

export const ModalSelectEvent = ({ event, show, handleClose, editEvent, onCancelEvent, confirmService }) => {
  return (
    <ModalDetailsEvent
      placement="right"
      title={!event?.isGroup ? <EventTitle event={event} /> : null}
      onCancel={handleClose}
      closable
      open={show}
      width={830}
      footer={
        !event?.isGroup ? (
          <EventActions
            event={event}
            editEvent={editEvent}
            onCancelEvent={onCancelEvent}
            confirmService={confirmService}
            onFinish={handleClose}
          />
        ) : null
      }
    >
      <FormWrapper>
        {event?.isGroup ? (
          event.events.map((item, index) => (
            <React.Fragment key={item.id}>
              {index > 0 ? <hr /> : null}
              <EventDetailsSummary
                event={item}
                showTitle
                showActions
                editEvent={editEvent}
                onCancelEvent={onCancelEvent}
                confirmService={confirmService}
                onFinish={handleClose}
              />
            </React.Fragment>
          ))
        ) : (
          <EventDetailsSummary event={event} />
        )}
      </FormWrapper>
    </ModalDetailsEvent>
  );
};

ModalSelectEvent.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    privateId: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    assignedUser: PropTypes.string,
    assignedServiceType: PropTypes.string,
    assignedFinalCustomer: PropTypes.object,
    confirmedByUser: PropTypes.bool,
    isGroup: PropTypes.bool,
    events: PropTypes.arrayOf(PropTypes.object),
    data: PropTypes.object,
  }),
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  editEvent: PropTypes.func,
  onCancelEvent: PropTypes.func,
  confirmService: PropTypes.func,
};
